module.exports = __webpack_public_path__ + "assets/ep3.png";